import { mapMessageFiles } from "../constants";
import { MessageTypesVerbose } from "../../../types/Chat";

type GetMessageFileConfig = (string) => {
    icon: string,
    type: MessageTypesVerbose
};

export const getMessageFileConfig: GetMessageFileConfig = (extension) => {
    return mapMessageFiles[extension] || {
        icon: '',
        type: MessageTypesVerbose.DOCUMENT_MESSAGE
    }
}